<template>
  <div class="online-service">
    <div class="service-mask" v-if="visible" @click="visible = false"></div>

    <div class="service-window" v-if="visible">
      <!-- <div class="service-header">
        <span>Online Customer Service</span>
        <i class="el-icon-close" @click="visible = false"></i>
      </div> -->
      <div class="service-body">
        <iframe v-if="chatUrl" :src="chatUrl" frameborder="0" class="chat-iframe"></iframe>
        <div v-else class="loading-placeholder">Loading...</div>
      </div>
    </div>

    <div class="service-float" @click="toggleService">
      <i class="el-icon-headset"></i>
    </div>
  </div>
</template>

<script>
import { getChatUrl } from '@/api/index'

export default {
  name: 'OnlineService',
  data() {
    return {
      visible: false,
      chatUrl: '',
      message: '',
      loaded: false
    }
  },
  methods: {
    async fetchChatUrl() {
      if (this.loaded) return
      try {
        const res = await getChatUrl({})
        if (res.code == '1' && res.data && res.data.url) {
          this.chatUrl = res.data.url
          this.loaded = true
        } else {
          console.error('getChatUrl failed', res.msg)
        }
      } catch (e) {
        console.error('getChatUrl error', e)
      }
    },
    toggleService() {
      this.visible = !this.visible
      if (this.visible && !this.loaded) {
        this.fetchChatUrl()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.online-service {
  position: fixed;
  right: 30px;
  bottom: 30px;
  z-index: 200;
}

.service-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.service-float {
  position: relative;
  z-index: 2;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #2e3a8f;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(46, 58, 143, 0.4);
}

.service-window {
  position: absolute;
  z-index: 2;
  right: 0;
  bottom: 70px;
  width: 750px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.service-header {
  background: #409eff;
  color: #fff;
  padding: 14px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;

  i {
    cursor: pointer;
  }
}

.service-body {
  padding: 0;
  min-height: 560px;
  height: 650px;

  .chat-iframe {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
    margin-top: -50px;
  }

  .loading-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 560px;
    color: #999;
    font-size: 14px;
  }
}
</style>
